// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2_nHD","title":"Images45_title__1Vg-r","images":"Images45_images__9GvuZ"};